/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const CloseIcon = createIcon({
  displayName: "CloseIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.06072 7.99908L12.5304 4.52941L11.4697 3.46875L8.00006 6.93842L4.53039 3.46875L3.46973 4.52941L6.9394 7.99908L3.46973 11.4688L4.53039 12.5294L8.00006 9.05974L11.4697 12.5294L12.5304 11.4688L9.06072 7.99908Z"
        fill="currentColor"
      />
    </g>
  )
});
